<script>
  import { onMount } from 'svelte';
  import settings from '../../config';
  import session from '../../lib/session';
  import { subdomain_from, default_subdomain } from '../../lib/utils';
  import { APIClient } from '../../state-charts';
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../../lib/translate.js';
  import GoogleAnalytics from '../GoogleAnalytics.svelte';

  onMount(async () => {
    window.addEventListener('keypress', e => {
      if (e.code === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    document.body.classList.add('orderer');

    // TODO: megvizsgalni az alabbiak szuksegesseget
    const subdomain = subdomain_from(window.location.host);
    if (!default_subdomain(settings, subdomain)) {
      session.write({ merchant_subdomain: subdomain });

      const response = await APIClient.get_merchant_style_by_subdomain({
        subdomain,
      });

      session.write({
        merchant: response.merchant,
        branding: {
          vars: response.merchant_style,
        },
      });

      APIClient.inject_style(response.merchant_style, window.location.origin);
    }
  });
</script>

<main class="main-content" id="main-content">
  <GoogleAnalytics />

  <slot name="content">
    <h1>{t9n(TS.MENU_NO_CONTENT)}</h1>
  </slot>
</main>

<style>
  body {
    display: flex;
    height: 100vh;
  }

  .main-content {
    overflow: auto;
    height: 100%;
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .main-content {
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
</style>
